export default {
  LIST_FETCHED: 'GROUPINGS_FETCHED',
  LIST_PARTICIPANTS_FETCHED: 'GROUPINGS_PARTICIPANTS_FETCHED',
  LIST_LOAD: 'GROUPINGS_LOAD',
  ITEM_DETAIL: 'GROUPINGS_DETAIL',
  BUTTON_LOAD: 'GROUPINGS_BUTTON_LOAD',
};
